<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd({})">
        <div class="flex-1 font-16-30313a">供应商分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="menuList && menuList.length">
        <cate-menu :menu-data="menuList" :permission="permission" :cateType="3" @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" @on-add="onAdd" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 ptb-10 pr-10 content flex-column">
      <div class="flex mb-10">
        <div class="title flex align-center flex-1 h-0 bg-ff">
          <div class="decoration-line mr-5"></div>
          <div class="font-16-f5971d font-bold">{{chooseMenu.name}}</div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-f5971d" @click="searchBtn">搜索</button>
        </div>
      </div>
      <!-- <div class="hr mb-10"></div> -->
      <div class="mb-5 flex align-center justify-space-between">
        <div class=" flex align-center">
          <div class="flex align-center mr-5 mb-5" @click="onOperate('add')" :class="0 === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(0)" @mouseleave="leave(0)">
            <img :src="0 === Index ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5" alt="">
            <div>添加供应商</div>
          </div>
          <div class="flex align-center mr-5 mb-5" @click="onOperate('delete')" :class="1 === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(1)" @mouseleave="leave(1)" v-if="permission.includes('deleteBusiness')">
            <img :src="1 === Index ? '/static/images/shanchu-bai.png' : '/static/images/shanchu.png'" class="icon-14 mr-5" alt="">
            <div>删除</div>
          </div>
        </div>
        <div class="flex align-center">
          <div class="btn-24-bd-e2 mr-5 flex align-center" style="min-width: 66px;">
            <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
            <el-upload multiple name="file" :httpRequest="httpRequestImport" :action="upImport" :show-file-list="false">
              <div style="margin: 10px auto 10px auto">导入</div>
            </el-upload>
          </div>
          <div class="btn-24-bd-e2 flex align-center mr-5" style="min-width: 66px;" @click="businessExport">
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            导出
          </div>
          <!-- <div class="btn-24-bd-e2 mr-5 flex align-center" style="min-width: 66px;">
            <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
            导入
          </div>
          <div class="btn-24-bd-e2 flex align-center mr-5" style="min-width: 66px;">
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            导出
          </div> -->
        </div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 mb-10">
        <erp-table :is-edit="true" ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData" @on-modify="onModifyRow" @set-pwd="setPwd" modify-method="on-modify" @get-enclosure="onChooseEnclosure"></erp-table>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="400px" :title="isAddMenu + '分类'" :visible.sync="isMenuShow" @closed="onCloseMenu">
      <div class="p-20">
        <div class="flex align-center">
          <div class="font-12-30313a mr-5">分类名称：</div>
          <el-input v-model="newMenuName" class="flex-1" placeholder="请输入供应商分类名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseMenu">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitMenu">确定</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="590px" title="附件" :visible.sync="isEnclosureShow" @closed="onCloseEnclosure">
      <el-scrollbar>
        <div class="enclosure-container">
          <div class="p-20">
            <div class="mb-10">
              <el-input type="textarea" :rows="5" resize="none" placeholder="请输入合同信息" v-model="enclosureInfo.contractInfo">
              </el-input>
            </div>
            <div class="flex mb-5">
              <el-upload multiple name="file" :httpRequest="httpRequestImg" :action="upload" :show-file-list="false">
                <div class="btn-24-bd-e2-bg-ff flex align-center bg-ff">
                  <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
                  上传
                </div>
              </el-upload>
            </div>
            <div class="flex flex-wrap" style="margin: 0 -5px" v-if="enclosureInfo.businessOptionList && enclosureInfo.businessOptionList.length">
              <div v-for="(item, index) in enclosureInfo.businessOptionList" :key="index" class="enclosure-item">
                <a :href="Utils.IMG_PREV+item.path" target="_blank"><img :src="getEnclosureTypeImg(item.path)" class="type-img" alt=""></a>
                <i class="el-icon-error" @click="removeEnclosure(index)"></i>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseEnclosure">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitEnclosure">保存</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
import ErpTable from '../../components/ErpTable'
import Pagination from '../../components/Pagination'
export default {
  name: 'businessDefine',
  components: { CateMenu, MoveHorizon, ErpTable, Pagination },
  data () {
    return {
      upImport: `${this.$store.state.API_URL_9010}/budget/import`,
      menuList: [],
      chooseMenuId: 0,
      chooseMenu: {},
      currentMenu: {},
      isAddMenu: '',
      isMenuShow: false,
      newMenuName: null,
      keywords: null,
      Index: -1,
      loading: false,
      columnData: [
        {
          field: 'select',
          type: 'selection',
          width: '40'
        }, {
          field: 'operate',
          title: '附件',
          width: '150',
          isDefine: true,
          child: [{
            className: 'btn-16-color-f5971d btn-hover-f5971d mr-5',
            title: '附件',
            methodName: 'get-enclosure',
            type: 'btn'
          }, {
            className: 'btn-16-color-f5971d btn-hover-f5971d mr-5',
            title: '重置密码',
            methodName: 'set-pwd',
            type: 'btn'
          }]
        }, {
          type: 'index',
          title: '序号',
          width: '60'
        }, {
          field: 'name',
          title: '供应商名称',
          minWidth: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'address',
          title: '联系地址',
          minWidth: '220',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'contact',
          title: '联系人',
          minWidth: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'contactTelephone',
          title: '联系电话',
          minWidth: '110',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'email',
          title: '邮箱',
          minWidth: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'idNumber',
          title: '证件号码',
          minWidth: '180',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableData: [],
      page: 1,
      limit: 25,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      isEnclosureShow: false,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      enclosureInfo: {},
      isClassifyShow: true,
      permission: []
    }
  },
  created () {
    this.getPermission()
  },
  mounted () {
    this.getAllMenu()
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'businessDefine',
        parentGroup: 'businessDefine'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    getAllMenu (notRefresh) {
      this.menuList = []
      this.axios.post(`businessClassify/findAll`, { companyId: this.$store.state.companyId }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) { // 默认展开
          res.data.data[i].isOpen = true
        }
        this.menuList = res.data.data
        if (!notRefresh) {
          this.getDefaultId(this.menuList)
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let menu = list[0]
        this.chooseMenuId = menu.id
        this.chooseMenu = menu
        this.$nextTick(() => {
          this.getData()
        })
      }
    },
    onAdd (menu) {
      this.isAddMenu = '新增'
      this.isMenuShow = true
      this.currentMenu = menu
    },
    onEdit (menu) {
      this.isAddMenu = '修改'
      this.isMenuShow = true
      this.currentMenu = menu
      this.newMenuName = menu.name
    },
    onDelete (menu) {
      let that = this
      this.$confirm(`此操作将永久删除${menu.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('businessClassify/deleteById', that.qs.stringify({ id: menu.id })).then(res => {
          if (res.data.success) {
            // that.getAllMenu(that.chooseMenuId !== menu.id)
            that.Utils.updateList(that.menuList, 2, { id: res.data.data })
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.chooseMenu = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.getData()
      }
    },
    onSubmitMenu () {
      if (!this.newMenuName) {
        this.$message({
          message: '请输入分类名称',
          type: 'warning'
        })
      } else {
        let that = this
        let callBack = function (res, type) {
          if (res.data.success) {
            that.$message({
              message: that.isAddMenu + '成功',
              type: 'success'
            })
            that.newMenuName = ''
            that.isMenuShow = false
            that.currentMenu = {}
            if (type === 1) {
              that.Utils.updateList(that.menuList, 1, res.data.data)
            } else {
              that.Utils.updateList(that.menuList, 0, res.data.data)
            }
            // that.getAllMenu(true)
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }
        if (this.isAddMenu === '新增') {
          let params = {
            name: this.newMenuName,
            companyId: this.$store.state.companyId,
            path: this.currentMenu.id ? this.currentMenu.path + ',' + this.currentMenu.id : '',
            parentId: this.currentMenu.id
          }
          this.axios.post('businessClassify/save', params).then(res => {
            callBack(res, 0)
          })
        } else {
          let params = {
            id: this.currentMenu.id,
            name: this.newMenuName
          }
          this.axios.post('businessClassify/modify', params).then(res => {
            callBack(res, 1)
          })
        }
      }
    },
    onCloseMenu () {
      this.isMenuShow = false
    },
    searchBtn () {
      this.page = 1
      this.chooseMenuId = 0
      this.isClassifyShow = false
      this.getAllMenu()
      this.getData()
    },
    onOperate (operate) {
      switch (operate) {
        case 'add':
          this.addData()
          break
        case 'delete':
          this.onDeleteData()
          break
      }
    },
    getData (isRefresh) {
      let params = {
        companyId: this.$store.state.companyId,
        page: this.page,
        limit: this.limit,
        keywords: this.keywords
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenu.id
      }
      this.axios.post(`business/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = []
          res.data.data.list.forEach(i => {
            i.unEditable = 'operate'
            this.tableData.push(i)
          })
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    addData () {
      let params = {
        companyId: this.$store.state.companyId,
        classifyId: this.chooseMenu.id
      }
      this.axios.post('business/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'name')
          this.total++
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onDeleteData () {
      let selectArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < selectArr.length; i++) {
        idArr.push(selectArr[i].id)
        nameArr.push(selectArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('business/deleteByIds', that.qs.stringify({ ids: idArr.join(',') })).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.erpTable.setAllSelection(false)
            that.getData(true)
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onModifyRow (row, column, colName) {
      let params = null
      params = {
        id: row.id,
        [colName]: row[colName],
        companyId: this.$store.state.companyId
        // classifyId: this.chooseMenu.id
      }
      this.axios.post('business/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    // 选择附件
    onChooseEnclosure (row) {
      this.enclosureInfo = {
        id: row.id,
        contractInfo: row.contractInfo,
        businessOptionList: row.businessOptionList || []
      }
      this.isEnclosureShow = true
    },
    // 重置密码
    setPwd (row) {
      let params = {
        id: row.id
      }
      this.axios.post('business/resetPassword', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.$message.success('重置密码成功')
          // this.getData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 3)
      formData.append('contractInfo', '')
      let that = this
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        that.enclosureInfo.businessOptionList.push({
          path: onloadRes.data.data.path
        })
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    getEnclosureTypeImg (path) {
      let type = path.substring(path.lastIndexOf('.') + 1)
      switch (type.toLowerCase()) {
        case 'doc':
        case 'docx':
          return '/static/images/word.png'
        case 'pdf':
          return '/static/images/pdf.png'
        case 'ppt':
          return '/static/images/ppt.png'
        case 'xls':
        case 'xlsx':
          return '/static/images/excel.png'
        case 'dwg':
          return '/static/images/cad.png'
        case 'txt':
          return '/static/images/txt.png'
        default:
          return '/static/images/other.png'
      }
    },
    removeEnclosure (index) {
      this.$confirm('点击保存之后才能真正删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.enclosureInfo.businessOptionList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onCloseEnclosure () {
      this.isEnclosureShow = false
    },
    submitEnclosure () {
      if (!this.enclosureInfo.businessOptionList.length) {
        this.$message({
          type: 'warning',
          message: '请选择您要上传的附件'
        })
      } else {
        this.axios.post('business/modifyByOption', {
          id: this.enclosureInfo.id,
          contractInfo: this.enclosureInfo.contractInfo,
          businessOptionParamList: this.enclosureInfo.businessOptionList
        }).then(res => {
          if (res.data.success) {
            this.getData()
            this.$message({
              message: '附件上传成功',
              type: 'success'
            })
            this.isEnclosureShow = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    jump (page) {
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    },
    enter (a) {
      this.Index = a
    },
    leave () {
      this.Index = -2
    },
    // 导入
    httpRequestImport (e) {
      let formData = new FormData()
      formData.append('file', e.file)
      formData.append('classifyId', this.chooseMenuId)
      this.axios.post(`${this.$store.state.API_URL_9010}/business/import`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: onloadRes.data.msg,
            type: 'success'
          })
          this.getData()
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        // this.$message.error('导入失败！')
      })
    },
    // 导出
    businessExport () {
      window.location.href = this.$store.state.API_URL_9010 + '/business/exportExcel?classifyId=' + this.chooseMenuId
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}
.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #f5971d;
  border-radius: 4px;
}
.content .title {
  height: 30px;
  padding-left: 10px;
  border-radius: 4px;
}
.search {
  overflow: hidden;
}
.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
.enclosure-container {
  max-height: 300px;
  .enclosure-item {
    width: 70px;
    height: 70px;
    background-color: #f3f4f7;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 5px 0;
    .type-img {
      width: 38px;
      height: 42px;
    }
    i {
      width: 14px;
      height: 14px;
      color: #ff5555;
      cursor: pointer;
      position: absolute;
      top: 2px;
      right: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/businessDefine.vue